import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { AccessibilityHiddenImg, AccessibilityClickableDiv } from '@skillz/accessibility';
import { removeSlashes } from '../../../utils/utils';
import logoIcon from '../../../assests/logo.png'
import Map from '../../shared/map/Map';
import Text from '../../shared/text/Text';
import TitlePages from '../shared/titlePages/TitlePages';
import pathRouts from '../../../enums/pathRoute';
import classes from './MainMenu.module.css';
import Logo from '../../shared/logo/Logo';


const MainMenu = () => {

    const { pathname } = useLocation();
    const user = useSelector((state) => state.auth.user);
    const [openMap, setOpenMap] = useState(true)
    const { texts } = useSelector(state => state.translate);
    const isHome = removeSlashes(pathname) === pathRouts.HOME.route;


    return (
        <div className={`${classes.MainMenu} ${openMap ? classes.Closed : classes.Open}`}>
            <AccessibilityClickableDiv aria-expanded={openMap} accessibilityDescription={texts.menu} className={classes.ArrowsBtn} onClick={() => setOpenMap(prev => !prev)} />

            <div className={classes.CloseContent}>
                <AccessibilityHiddenImg className={classes.Logo} src={logoIcon} />
                {!isHome &&
                    <div className={classes.TitlePageContent} onClick={() => setOpenMap(prev => !prev)} >
                        <TitlePages pathname={pathname} fromMenu={true} />
                        <div className={classes.Triangular}></div>
                    </div>
                }
            </div>

            <div className={classes.OpenContent}>
                <div className={classes.Bordered}>
                    <div className={classes.Title}>
                        <div className={classes.UserNameWrapper}>
                            <p className={classes.UserName}>{user?.given_name ? `${user?.given_name} ${user?.family_name},` : ''}</p>
                            <p className={classes.WelcomeText}>{texts.welcome}</p>
                        </div>
                        <div className={classes.Line} />
                    </div>
                    <div className={`${classes.MapWrapper} ${isHome ? classes.HomeMapWrapper : ''}`}>
                        <Map showArrow={true} isExpanded={openMap} />
                    </div>
                </div>
            </div>
        </div>
    )


}

export default MainMenu;